<template>
  <ServiceBoxes :serviceBoxes="serviceBoxes" @serviceBoxClicked="handleServiceBoxClicked" />
</template>

<script lang="ts" setup>
import { resolveUrl } from '@/helpers/HgLink/HgLinkHelper';

import { useI18n } from 'vue-i18n';
import { ServiceBoxConfig } from './helpers/serviceboxes-helpers';
import ServiceBoxes from './ServiceBoxes.vue';
import { trackServiceBoxClicked } from './tracking';

const { t } = useI18n();

defineOptions({
  name: 'ServiceBoxesContainer',
});

interface Props {
  serviceBoxes: ServiceBoxConfig[];
}
const props = defineProps<Props>();

const emit = defineEmits<{
  serviceBoxClicked: [serviceBox: ServiceBoxConfig];
}>();

const handleServiceBoxClicked = (servicebox: ServiceBoxConfig): void => {
  trackServiceBoxClicked(
    servicebox.eventName,
    servicebox.link.href ? resolveUrl(t(servicebox.link.href).toString()) : '',
  );
  emit('serviceBoxClicked', servicebox);
};
</script>
